import Vue from 'vue'
import Router from 'vue-router'

// Containers
import Full from '@/containers/Full'

// Views
import Dashboard from '@/views/Dashboard'
import SensorData from '@/views/SensorData'
import Targets from '@/views/Targets'
import Alerts from '@/views/Alerts'
import Rules from '@/views/Rules'
import CreateRule from '@/views/CreateRule'
import Account from '@/views/Account'
import Sites from '@/views/Sites'
import DeviceSettings from '@/views/DeviceSettings'
import SensorEdit from '@/views/SensorEdit'
import AdminInterface from '@/views/AdminInterface'
import TeamManagement from '@/views/TeamManagement'
import SiteManagement from '@/views/SiteManagement'
import ManualReadings from '@/views/ManualReadings'
import HistoricalImport from '@/views/HistoricalImport'
import DeviceHealth from '@/views/DeviceHealth'
import Maintenance from '@/views/Maintenance'
import SensorCalibration from '@/views/SensorCalibration'
import About from '@/views/About'
import AuditLog from '@/views/AuditLog'

import UserProfile from '@/components/account/UserProfile'
import ChangePassword from '@/components/account/ChangePassword'

// Views - Static Pages
import Page404 from '@/views/pages/Page404'
import Page500 from '@/views/pages/Page500'
import Login from '@/views/pages/Login'
import Register from '@/views/pages/Register'

// Utilities
import { requireAuth } from '@/lib/auth'
import { requireAdmin } from '@/lib/role-guard'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      name: 'Home',
      redirect: '/sensor-data/well',
      component: Full,
      beforeEnter: requireAuth,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard,
          redirect: '/sensor-data/well'
        },
        {
          path: 'sensor-data/:deviceType',
          name: 'Sensor Data',
          component: SensorData,
          props: true
        },
        {
          path: '/sites',
          name: 'Sites',
          component: Sites
        },
        {
          path: '/targets',
          name: 'Notification Targets',
          component: Targets
        },
        {
          path: '/alerts',
          name: 'Alerts',
          component: Alerts
        },
        {
          path: '/create-rule',
          name: 'Create Rule',
          component: CreateRule
        },
        {
          path: '/rules',
          name: 'Rules',
          component: Rules
        },
        {
          path: '/account',
          name: 'Account',
          redirect: '/account/profile',
          component: Account,
          children: [
            {
              path: 'profile',
              name: 'Profile',
              component: UserProfile
            },
            {
              path: 'change-password',
              name: 'Change Password',
              component: ChangePassword
            }
          ]
        },
        {
          path: '/device-health',
          name: 'Device Health',
          component: DeviceHealth
        },
        {
          path: '/settings/devices',
          name: 'Device Configuration',
          component: DeviceSettings,
          beforeEnter: requireAdmin
        },
        {
          path: '/settings/sensors/:sensorId',
          name: 'Sensor Edit',
          component: SensorEdit,
          props: true,
          beforeEnter: requireAdmin
        },
        {
          path: '/settings/admin',
          name: 'Admin Interface',
          component: AdminInterface,
          beforeEnter: requireAdmin
        },
        {
          path: '/settings/teams',
          name: 'Team Management',
          component: TeamManagement,
          beforeEnter: requireAdmin
        },
        {
          path: '/settings/sites',
          name: 'Site Management',
          component: SiteManagement,
          beforeEnter: requireAdmin
        },
        {
          path: '/settings/manual-readings',
          name: 'Manual Readings',
          component: ManualReadings,
          beforeEnter: requireAdmin
        },
        {
          path: '/settings/historical-import',
          name: 'Historical Import',
          component: HistoricalImport,
          beforeEnter: requireAdmin
        },
        {
          path: '/settings/maintenance',
          name: 'Maintenance',
          component: Maintenance,
          beforeEnter: requireAdmin
        },
        {
          path: '/settings/sensors/:sensorId/calibrate',
          name: 'Sensor Calibration',
          component: SensorCalibration,
          props: true,
          beforeEnter: requireAdmin
        },
        {
          path: '/settings/audit-log',
          name: 'Audit Log',
          component: AuditLog,
          beforeEnter: requireAdmin
        },
        {
          path: '/about',
          name: 'About',
          component: About
        }
      ]
    },
    {
      path: '/auth',
      redirect: '/auth/login',
      name: 'Auth',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
          path: 'register',
          name: 'Register',
          component: Register
        }
      ]
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        }
      ]
    },
    {
      path: '*',
      redirect: '/pages/404',
      name: 'Wildcard404',
      component: {
        render (c) { return c('router-view') }
      }
    }
  ]
})
